export default __webpack_public_path__ + "static/media/mobile.30c6066b.svg";